/* tslint:disable */

declare var Object: any;
export interface ViewHeadcountMaritalInterface {
  "total": number;
  "maritalstatus": number;
}

export class ViewHeadcountMarital implements ViewHeadcountMaritalInterface {
  "total": number;
  "maritalstatus": number;
  constructor(data?: ViewHeadcountMaritalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewHeadcountMarital`.
   */
  public static getModelName() {
    return "ViewHeadcountMarital";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewHeadcountMarital for dynamic purposes.
  **/
  public static factory(data: ViewHeadcountMaritalInterface): ViewHeadcountMarital{
    return new ViewHeadcountMarital(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewHeadcountMarital',
      plural: 'ViewHeadcountMaritals',
      path: 'ViewHeadcountMaritals',
      properties: {
        "total": {
          name: 'total',
          type: 'number'
        },
        "maritalstatus": {
          name: 'maritalstatus',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewHeadcountMarital.ts